import { ReactNode } from 'react'
import Header from './Header'
import Sidebar from './Sidebar'
import './MainLayout.css'

interface MainLayoutProps {
  children: ReactNode
}

function MainLayout({ children }: MainLayoutProps) {
  return (
    <div className="flex flex-col h-screen overflow-hidden main-layout">
      <Header />
      <main className="relative flex-1 p-4 overflow-y-auto overflow-x-hidden w-full max-w-full box-border main-layout__main md:p-6 md:max-w-[1200px] lg:max-w-[1400px] lg:p-8 xl:max-w-[1600px] xl:p-8">
        {children}
      </main>
      <Sidebar />
    </div>
  )
}

export default MainLayout

